import { InputByTypeProperties } from '@/models/form-builder-interface';

/**
 * Table information used for displaying matrix tabs
 * - id: Position ID from account/position API
 * - name: Display name for the table
 * - treeId: Tree ID for this position
 * - treeLevel: Level in the tree structure
 * - offset: Offset of the position in the tree
 */
export interface TableInfo {
  id: number | string;
  name: string;
  treeId: number;
  treeLevel: number;
  offset: number;
}

/**
 * Table entry for configuration
 * Defines which positions in the tree should be shown as tables
 */
export interface TableEntry {
  treeId: number;
  offset: number;
  name: string;
}


export type RevolverMatrixProps = {
  id?: string;
  width?: number;
  treeId?: number;
  tables?: TableEntry[];
  noTableFoundText?: string;
  properties?: string[];
  popupProperties?: string[];
  headerTitles?: Record<string, string>;
  inputProperties?: InputByTypeProperties;
  titleField?: string;
  subtitleField?: string;
  titleFieldMax?: number;
  subtitleFieldMax?: number;

  // Wrapper Styles
  backgroundColor?: string;
  tabsWrapperClass?: string;
  tabsClass?: string;
  matrixWrapperClass?: string;
  contentWrapperClass?: string;
  loaderColor?: string;
  tabsSliderColor?: string;
  tableChipColor?: string;

  // Card Styles
  cardBackgroundColor?: string;
  emptySlotColor?: string;
  cardClass?: string;
  emptyCardClass?: string;
  cardTitleColor?: string;
  cardSubtitleColor?: string;
  arrowColor?: string;

  // Avatar Sizes
  avatarSizeLevel0?: number;
  avatarSizeLevel1?: number;
  avatarSizeLevel2?: number;

  // Empty Slot Behavior
  forceMiniCards?: boolean;
  showEmptyIcon?: boolean;
  emptyText?: string;

  // Editable Properties (for spillover)
  editableProperties?: string[];
  editPermission?: 'self' | 'all' | 'none';
}

export const defaults = {
  width: 2,
  treeId: 0,
  tables: [] as TableEntry[],
  noTableFoundText: 'Для вашей позиции нет столов',
  properties: [] as string[],
  popupProperties: [] as string[],
  titleField: 'p.title',
  subtitleField: 's.id',
  titleFieldMax: 20,
  subtitleFieldMax: 15,

  // Wrapper Styles
  backgroundColor: '#F1F1F1',
  tabsWrapperClass: 'mb-2',
  tabsClass: 'rounded-lg',
  matrixWrapperClass: '',
  contentWrapperClass: 'pa-4 rounded-lg',
  loaderColor: '#ffffff',
  tabsSliderColor: '#000000',
  tableChipColor: '#000000',

  // Card Styles
  cardBackgroundColor: '#ffffff',
  emptySlotColor: '#e0e0e0',
  cardClass: '',
  emptyCardClass: '',
  cardTitleColor: '#000000',
  cardSubtitleColor: '#757575',
  arrowColor: '#ffffff',

  // Avatar Sizes
  avatarSizeLevel0: 60,
  avatarSizeLevel1: 50,
  avatarSizeLevel2: 40,

  // Empty Slot Behavior
  forceMiniCards: false,
  showEmptyIcon: true,
  emptyText: '',

  // Editable Properties (for spillover)
  editableProperties: [] as string[],
  editPermission: 'self' as const,
};
